const isDebug = process.env.NODE_ENV === "development";

export default isDebug;
